import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Loading from "@components/loading";
import { getArticles } from "@queries/articles";
import { queryClient } from "@queries/query-client";
import React, { useEffect, useState } from "react";
import { useQuery } from "react-query";
import ArticleItem from "./article-item";
import ArticlePager from "./article-pager";
var ArticlesList = function(param) {
    var _profileName = param.profileName, profileName = _profileName === void 0 ? "" : _profileName, type = param.type;
    var _a, _b, _c;
    var ref = useState(10), pageSize = ref[0], setPageSize = ref[1];
    var ref1 = useState(0), pageNumber = ref1[0], setPageNumber = ref1[1];
    var ref2 = useQuery([
        "articleQueryFromProps",
        type,
        profileName,
        pageSize,
        pageNumber
    ], function() {
        return getArticles(profileName, type, pageSize, pageNumber);
    }, {
        keepPreviousData: true,
        staleTime: 5000
    }), isLoading = ref2.isLoading, data = ref2.data;
    useEffect(function() {
        setPageNumber(0);
    }, [
        pageSize
    ]);
    useEffect(function() {
        if ((data === null || data === void 0 ? void 0 : data.data.response.numFound) > (pageNumber + 1) * 10) {
            queryClient.prefetchQuery([
                "articleQueryFromProps",
                type,
                profileName,
                pageSize,
                pageNumber + 1
            ], function() {
                return getArticles(profileName, type, pageSize, pageNumber + 1);
            });
        }
    }, [
        data,
        pageNumber,
        type,
        profileName,
        pageSize
    ]);
    if (isLoading) {
        return /*#__PURE__*/ _jsx(Loading, {});
    }
    return /*#__PURE__*/ _jsxs("div", {
        className: "bg-white w-full p-4",
        children: [
            ((_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.response.numFound) === 0 && /*#__PURE__*/ _jsx("div", {
                children: "No articles found"
            }),
            ((_b = data === null || data === void 0 ? void 0 : data.data) === null || _b === void 0 ? void 0 : _b.response.numFound) > 0 && /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    (_c = data === null || data === void 0 ? void 0 : data.data) === null || _c === void 0 ? void 0 : _c.response.docs.map(function(article) {
                        return /*#__PURE__*/ _jsx(ArticleItem, _object_spread({}, article), article.id);
                    }),
                    /*#__PURE__*/ _jsx(ArticlePager, {
                        count: data.data.response.numFound,
                        pageNumber: pageNumber,
                        pageSize: pageSize,
                        setPageNumber: setPageNumber,
                        setPageSize: setPageSize
                    })
                ]
            })
        ]
    });
};
export default ArticlesList;
